import axios from 'axios';

export const listAccountingInvoicesApi = async ({ customerId, search, withoutSetOff, availableForRepayment } = {}) => {
  const params = {};
  if (customerId) {
    params.customerId = customerId;
  }
  if (search) {
    params.search = search;
  }
  if (withoutSetOff) {
    params.withoutSetOff = true;
  }
  if (availableForRepayment) {
    params.availableForRepayment = true;
  }
  const response = await axios.get('/admin/accounting-invoices', { params });
  return response.data;
};

export const getAccountingInvoiceApi = async ({ invoiceId }) => {
  const response = await axios.get(`/admin/accounting-invoices/${invoiceId}`);
  return response.data;
};

export const createAccountingInvoiceApi = async (invoice) => {
  const response = await axios.post('/admin/accounting-invoices', invoice);
  return response.data;
};

export const deleteAccountingInvoiceApi = async ({ invoiceId }) => {
  const response = await axios.delete(`/admin/accounting-invoices/${invoiceId}`);
  return response.data;
};

export const addAccountingInvoiceSetOffApi = async ({ invoiceId, setOff }) => {
  const response = await axios.post(`/admin/accounting-invoices/${invoiceId}/set-off`, setOff);
  return response.data;
};

export const listCustomerInvoiceNumbersApi = async ({ customerId }) => {
  const response = await axios.get(
    `/admin/customer/${customerId}/accounting-invoices/invoice-numbers`
  );
  return response.data;
};

export const getCustomerBillingDetailsApi = async ({ customerId }) => {
  const response = await axios.get(`/admin/customer/${customerId}/billing-details`);
  return response.data;
};

export const upsertCustomerBillingDetailsApi = async ({ customerId, billingDetails }) => {
  const response = await axios.put(
    `/admin/customer/${customerId}/billing-details`,
    billingDetails
  );
  return response.data;
};

export const getUserInvoiceSignatureApi = async () => {
  // The caller treats a failure as "no stored signature" and carries on, so a
  // 401 here must not bounce the user out of the form they are filling in.
  const response = await axios.get('/admin/accounting/user-signature', {
    skipAuthRedirect: true,
  });
  return response.data;
};

export const upsertUserInvoiceSignatureApi = async ({ dataUrl, signerName }) => {
  const response = await axios.put('/admin/accounting/user-signature', {
    dataUrl,
    signerName,
  });
  return response.data;
};

export const markAccountingInvoicePaidApi = async ({ invoiceId }) => {
  const response = await axios.post(`/admin/accounting-invoices/${invoiceId}/mark-paid`);
  return response.data;
};

// Undoes the above, restoring whatever the invoice's repayments and set-off
// actually cover. The endpoint is live; nothing in the cockpit calls it yet —
// see the commented block in InvoiceDetail for the button that would.
export const unmarkAccountingInvoicePaidApi = async ({ invoiceId }) => {
  const response = await axios.post(`/admin/accounting-invoices/${invoiceId}/unmark-paid`);
  return response.data;
};
